export default{
    statisticsApi: 'principal/statistics-dev',
    gradeInfoApi: 'principal/getgradeinfo-dev',
    searchUserApi: 'principal/searchuser-dev',
    schoolListApi: 'schools/list',
    downloadgradeCsvApi: 'principal/schoolreport/downloadgradecsv-dev',
    chaptercompletionCountApi: 'principal/chaptercompletioncount-dev',
    subjectinfoApi: 'principal/getsubjectinfo-dev',
    chapterinfoApi: 'principal/getchapterinfo-dev',
    topicinfoApi: 'principal/gettopicinfo-dev',
    chapterwisereportApi: 'principal/schoolreport/chapterwisereport-dev',
    barchartdetailsApi: 'principal/barchartdetails-dev',
    schoolReportCsvApi: 'principal/schoolreport/schoolreportdownload-dev',
    barchartStudentListApi: 'principal/barchartdetails-dev',

    master_gradeInfoApi:'principal-master-api/getgradeinfo-dev',
    master_searchUserApi:'principal-master-api/searchuser-dev',
    master_statisticsApi:'principal-master-api/statistics-dev',
    master_statisticsInsightApi:'principal-master-api/statistics-dev/statisticsinsight-dev',
    master_statisticsuserListApi:'principal-master-api/statistics-dev/statisticsuserlist-dev',
    master_downloadgradeCsvApi:'principal-master-api/schoolreport/downloadgradecsv-dev',
    master_chaptercompletionCountApi: 'principal/chaptercompletioncount-dev',
    master_subjectinfoApi: 'principal-master-api/getsubjectinfo-dev',
    master_chapterinfoApi: 'principal-master-api/getchapterinfo-dev',
    master_topicinfoApi:'principal-master-api/gettopicinfo-dev',
    master_barchartdetailsApi:'principal/barchartdetails',
    master_schoolreportdownloadApi: 'principal-master-api/schoolreport/schoolreportdownload-master-dev',
    master_chapterwisereportApi: 'principal/schoolreportdownload/chapterwisereport',

    parentView1Api:'parent/parentviewpart-1-dev',
    parentView2Api:'parent/parentviewpart-2-dev',

    dev_parentView1Api:'parent/parentviewpart-1-dev',
    dev_parentView2Api:'parent/parentviewpart-2-dev',

    dev_studentView1Api:'parent/parentviewpart-1-dev',
    dev_studentView2Api:'parent/parentviewpart-2-dev',

    dev_statisticsApi: 'principal/statistics-dev',
    dev_gradeInfoApi: 'principal/getgradeinfo-dev',
    dev_searchUserApi: 'principal/searchuser-dev',
    dev_schoolListApi: 'schools/list',
    dev_downloadgradeCsvApi: 'principal/schoolreport/downloadgradecsv-dev',
    dev_chaptercompletionCountApi: 'principal/chaptercompletioncount-dev',
    dev_subjectinfoApi: 'principal/getsubjectinfo-dev',
    dev_chapterinfoApi: 'principal/getchapterinfo-dev',
    dev_topicinfoApi: 'principal/gettopicinfo-dev',
    dev_chapterwisereportApi: 'principal/schoolreport/chapterwisereport-dev',
    dev_barchartdetailsApi: 'principal/barchartdetails-dev',
    dev_schoolReportCsvApi: 'principal/schoolreport/schoolreportdownload-dev',
    dev_barchartStudentListApi: 'principal/barchartdetails-dev',

    dev_master_gradeInfoApi:'principal-master-api/getgradeinfo-dev',
    dev_master_searchUserApi:'principal-master-api/searchuser-dev',
    dev_master_statisticsApi:'principal-master-api/statistics-dev',
    dev_master_statisticsInsightApi:'principal-master-api/statistics-dev/statisticsinsight-dev',
    dev_master_statisticsuserListApi:'principal-master-api/statistics-dev/statisticsuserlist-dev',
    dev_master_downloadgradeCsvApi:'principal-master-api/schoolreport/downloadgradecsv-dev',
    dev_master_chaptercompletionCountApi: 'principal/chaptercompletioncount-dev',
    dev_master_subjectinfoApi: 'principal-master-api/getsubjectinfo-dev',
    dev_master_chapterinfoApi: 'principal-master-api/getchapterinfo-dev',
    dev_master_topicinfoApi:'principal-master-api/gettopicinfo-dev',
    dev_master_barchartdetailsApi:'principal/barchartdetails',
    dev_master_schoolreportdownloadApi: 'principal-master-api/schoolreport/schoolreportdownload-master-dev',
    dev_master_chapterwisereportApi: 'principal/schoolreportdownload/chapterwisereport'

}